(ns kyber.interceptors.analytics
  (:require [re-frame.core :as re-frame]

            [kyber.utils :refer [gen-cid]]
            [kyber.constants :as c]))

;; This should only be modified on page refresh
(defonce session-uuid (str (random-uuid)))

(def analytics
  (re-frame/->interceptor
   :id
   :analytics/track

   ;; We have to perform analytic actions after the final handler has
   ;; run becuase we don't want our dispatch-n to be overriden by a
   ;; given handlers dispatch-n
   :after
   (fn [context]
     (let [{:keys [event]}
           (:coeffects context)

           [event-name {:keys [analytic/data]}]
           event]

       (update-in context
                  [:effects :dispatch-n]
                  #(let [event [:analytics/save-datapoint
                                (cond-> {:event event-name}
                                  (not (nil? data))
                                  (merge data))]]
                     (if %
                       (conj % event)
                       [event])))))))

(defn- get-host [] (-> js/window .-location .-host))
(defn- get-path [] (-> js/window .-location .-pathname))

(defonce authentication-page :authentication)
(defonce legal-page :legal)
(defonce curriculum-page :curriculum)
(defonce activity-page :activity)
(defonce settings-page :settings)

(def analytic-route-mapping
  {:unauthenticated-home authentication-page
   :sign-in authentication-page
   :sign-up authentication-page
   :forgot-password authentication-page
   :reset-password authentication-page

   :privacy-policy legal-page
   :terms-and-conditions legal-page

   :activity-selection curriculum-page

   :activity activity-page
   :activity-results activity-page
   :questionnaire-splash activity-page
   :questionnaire-results activity-page
   :active-questionnaire-question activity-page

   :profile settings-page})

(def update-application-context
  (re-frame/->interceptor
   :id
   :analytics/update-application-context

   :after
   (fn [context]
     (let [db
           (re-frame/get-effect context :db)

           sub
           (get-in db [:session :user :sub])

           {:keys [analytics-schema-version custom-analytics]}
           (:configuration db)

           acid
           (gen-cid)

           {:keys [route-params route-query route]}
           (:router db)

           route-key
           (or (analytic-route-mapping route) route)]

       (re-frame/assoc-effect
        context
        :db
        (-> db
            (assoc-in [:analytics :application-contexts acid]
                      (merge custom-analytics
                             {:schema-version analytics-schema-version
                              :client-sub sub
                              :app-name @c/app-name
                              :url {:host (get-host)
                                    :path (get-path)
                                    :route-key route-key
                                    :route-params route-params
                                    :route-query route-query}
                              :session-uuid session-uuid}))
            (update-in [:analytics :application-context-ids]
                       conj acid)))))))
